import { UnknownAction } from '@reduxjs/toolkit'
import { createReducer } from '@reduxjs/toolkit/react'
import { DemoType } from '@repo/shared/dtos/organization'
import { Language } from '@repo/ui/lang'
import { AsyncData, DataStatus } from '@repo/ui/utils'

import { SudoContextOrganization } from '@/store/sudo'

import { demoStoreActions } from './actions'

export type OrganizationDemo = SudoContextOrganization & {
  key?: DemoType
  language?: Language
}

export type DemoState = {
  organizations: AsyncData<OrganizationDemo[]>
  resettingOrganizationId: string | null
}

export const demoInitialState: DemoState = {
  organizations: DataStatus.Uninitialized,
  resettingOrganizationId: null,
}

export const demoReducer: ((state: DemoState | undefined, action: UnknownAction) => DemoState) & {
  getInitialState: () => DemoState
} = createReducer(demoInitialState, (builder) => {
  builder
    .addCase(demoStoreActions.initDemo.pending, (state) => {
      state.organizations = DataStatus.Loading
    })
    .addCase(demoStoreActions.initDemo.rejected, (state) => {
      state.organizations = DataStatus.Error
    })
    .addCase(demoStoreActions.initDemo.fulfilled, (state, { payload: { organizations } }) => {
      state.organizations = organizations
    })

  builder
    .addCase(
      demoStoreActions.resetDemo.pending,
      (
        state,
        {
          meta: {
            arg: { organizationId },
          },
        },
      ) => {
        state.resettingOrganizationId = organizationId
      },
    )
    .addCase(demoStoreActions.resetDemo.fulfilled, (state) => {
      state.resettingOrganizationId = null
    })
    .addCase(demoStoreActions.resetDemo.rejected, (state) => {
      state.resettingOrganizationId = null
    })
})
